const LOOKUP_GLOBAL_NAME = '_ace_debug_lookup';
const GLOBAL_ACCESSOR_NAME = 'aceDebug';

const addLookup = (name, value) => {
  let glob = global || window || this;

  if (!glob.hasOwnProperty (LOOKUP_GLOBAL_NAME)) {
    glob[LOOKUP_GLOBAL_NAME] = {};
  }
  glob[LOOKUP_GLOBAL_NAME][name] = value || false;

  if (glob.hasOwnProperty ('localStorage')) {
    glob.localStorage.setItem (LOOKUP_GLOBAL_NAME, JSON.stringify(glob[LOOKUP_GLOBAL_NAME]));
    glob[LOOKUP_GLOBAL_NAME] = JSON.parse (glob.localStorage.getItem (LOOKUP_GLOBAL_NAME));
  }
};

const lookup = (name) => {
  let glob = global || window || this;
  if (glob.hasOwnProperty(LOOKUP_GLOBAL_NAME)) {
    if (glob[LOOKUP_GLOBAL_NAME].hasOwnProperty (name)) {
      return glob[LOOKUP_GLOBAL_NAME][name];
    }
  }
  return false;
};

const addGlobalAccess = (name) => {
  let glob = global || window || this;

  if (!glob.hasOwnProperty (GLOBAL_ACCESSOR_NAME)) {

    if (glob.hasOwnProperty ('localStorage')) {
      let storageItem = glob.localStorage.getItem (LOOKUP_GLOBAL_NAME);
      if (storageItem) {
        glob[LOOKUP_GLOBAL_NAME] = JSON.parse (storageItem);
      }
    }

    glob[GLOBAL_ACCESSOR_NAME] = (...names) => {
      return {
        get on () {
          names.forEach (name => addLookup (name, true));
          return true;
        },
        get off () {
          names.forEach (name => addLookup (name, false));
          return false;
        }
      };
    };

    Object.defineProperty (glob[GLOBAL_ACCESSOR_NAME], 'list', {
      get () {
        return Object.keys(glob[LOOKUP_GLOBAL_NAME] || {});
      }
    });

    Object.defineProperty (glob[GLOBAL_ACCESSOR_NAME], 'signInUsingAceLogin', {
      get () {
        return () => {
          try {
            if (window._loginUsingAce) {
              window._loginUsingAce();
            } else {
              throw 'error';
            }
          } catch (e) {
            console.log ('No can do! Only works when cognito-modal is open.');
          }
        };
      }
    });
  }

  if (!glob.hasOwnProperty(LOOKUP_GLOBAL_NAME)) {
    glob[LOOKUP_GLOBAL_NAME] = {};
  }
  glob[LOOKUP_GLOBAL_NAME][name] = glob[LOOKUP_GLOBAL_NAME][name] || false;
};

/**
 * Module level debug logging controlled from global scope.
 *
 * The log method works pretty much as console.log but prefixes
 * logs with a name.
 * Usage:
 *
 * @example
 * import Debug from 'ace-ui/ace-debug';
 * const debug = new Debug ('name-of-debug-entity');
 *
 * debug.log ('This is useful developer info');
 *
 * debug.status // -> true or false
 * @end
 *
 * To control logging a global function is available:
 * @example
 * aceDebug ('name-of-debug-entity').on // enables debugging
 * @end
 *
 * Enable logging of multiple entities
 * @example
 * aceDebug ('entity-one', 'entity-two', ...someList).on
 * @end
 *
 * List of debuggable entities
 * @example
 * aceDebug.list
 * @end
 *
 * Disable logging for all entities
 * @example
 * aceDebug(...aceDebug.list).off
 * @end
 */
export default class {
  constructor (name) {
    this.name = name;
    addGlobalAccess (this.name);
  }
  get status () {
    return lookup(this.name);
  }
  on () {
    addLookup (this.name, true);
  }
  off () {
    addLookup (this.name, false);
  }
  log (...args) {
    if (this.status) {
      console.log.apply (this, [`%c${this.name}:`, 'color: #3d9970;font-weight: bold', ...args]);
    }
  }
}
